<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>
<template>
  <!-- 绑定邮箱模态框 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    :title="$t('绑定邮箱')"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <p class="tips">{{ $t('邮箱') }}</p>
      <el-form-item prop="email">
        <el-input
          v-model="formData.email"
          size="large"
          :placeholder="$t('请输入邮箱地址')"
        />
      </el-form-item>

      <el-form-item prop="code">
        <p class="tips">{{ $t('邮箱验证码') }}</p>
        <div class="code-box">
          <el-input
            v-model="formData.code"
            size="large"
            :placeholder="$t('请输入邮箱验证码')"
          />
          <verify-code
            ref="verifyCodeRef"
            :rebase="vis"
            @click="getCode"
          ></verify-code>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="loading" @click="bindEmailHandle">{{
        $t('确定')
      }}</el-button>
    </template>
  </Modal>
  <!-- 绑定邮箱模态框 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
import { ajax_sendSms, ajax_bindEmail } from '@/api/personal'
import { ajaxSmsHandle, updateUserInfo } from '@/utils'

export default {
  name: 'EmailModal',
  extends: ModalBase,
  data() {
    return {
      formData: {
        email: '',
        code: ''
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t('请输入邮箱地址'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('请填写邮箱验证码！'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    getCode(e) {
      this.$refs.formRef.validateField('email', async (validateRes) => {
        if (validateRes) {
          e.sendFail()
          return
        }
        ajaxSmsHandle(
          ajax_sendSms({
            account: this.formData.email,
            type: 'bandingEmail'
          }),
          e
        )
      })
    },
    async bindEmailHandle() {
      await this.$refs.formRef.validate()
      // 确认绑定邮箱
      this.loading = true
      try {
        await ajax_bindEmail(this.formData)
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.vis = false
      } finally {
        this.loading = false
      }
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
.tips {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-bottom: 10px;
}
.code-box {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
</style>
